import { useAppDispatch, useAppSelector } from 'app/core/hooks'
import { comboProduct } from 'app/core/models/slice/combo/comboProduct'
import { comboProductList } from 'app/core/models/slice/combo/comboProductList'
import { joinProductIf } from 'app/core/models/slice/prd/joinProduct'
import { clearTrnsKeyInfo } from 'app/core/slices/com/trnsKeyInfo.slice'
import {
    clearComboProduct,
    setComboProductObArr,
} from 'app/core/slices/product/comboProduct.slice'
import {
    clearComboProductList,
    setComboProductListObArr,
} from 'app/core/slices/product/comboProductList.slice'
import {
    clearJoinProcessData,
    clearJoinProduct,
    setJoinProductArr,
    setJoinProductObArr,
} from 'app/core/slices/product/joinProduct.slice'
import {
    MobileAuth,
    setMobileAuthObArr,
} from 'app/core/slices/user/mobileAuth.slice'
import { setCusInfoObArr, User } from 'app/core/slices/user/user.slice'

export const useProductJoin = () => {
    /* Product Store */
    const joinProduct = useAppSelector((state) => state.joinProduct)

    /* User Store */
    const user = useAppSelector((state) => state.user)
    const mobileAuth = useAppSelector((state) => state.mobileAuth)
    const bankingInfo = useAppSelector((state) => state.bankingInfo)
    const comboProduct = useAppSelector((state) => state.comboProduct)
    const comboProductList = useAppSelector((state) => state.comboProductList)

    /* Dispatcher */
    const dispatch = useAppDispatch()

    const _clearJoinProduct = () => {
        dispatch(clearJoinProduct())
    }

    const _clearJoinProcessData = () => {
        dispatch(clearJoinProcessData())
    }

    const _clearTrnsKeyInfo = () => {
        dispatch(clearTrnsKeyInfo())
    }

    const _clearComboProduct = () => {
        dispatch(clearComboProduct())
    }
    const _clearComboProductList = () => {
        dispatch(clearComboProductList())
    }

    const _setJoinProductArr = (data: { key: string; value: any }[]) => {
        dispatch(setJoinProductArr(data))
    }

    const _setJoinProductObArr = (data: Partial<joinProductIf>) => {
        dispatch(setJoinProductObArr(data))
    }

    const _setMobileAuthObArr = (data: Partial<MobileAuth>) => {
        dispatch(setMobileAuthObArr(data))
    }

    const _setCusInfoObArr = (data: Partial<User['cusInfo']>) => {
        dispatch(setCusInfoObArr(data))
    }

    const _setComboProductObArr = (comboProduct: comboProduct) => {
        // comboProduct
        dispatch(setComboProductObArr(comboProduct))
    }
    const _setComboProductListObArr = (comboProductList: comboProduct[]) => {
        // comboProductList
        dispatch(
            setComboProductListObArr({
                comboProductList: comboProductList,
            })
        )
    }

    return {
        joinProduct: joinProduct,
        user: user,
        mobileAuth: mobileAuth,
        bankingInfo: bankingInfo,
        comboProduct: comboProduct,
        comboProductList: comboProductList,
        clearJoinProduct: _clearJoinProduct,
        clearJoinProcessData: _clearJoinProcessData,
        clearTrnsKeyInfo: _clearTrnsKeyInfo,
        clearComboProduct: _clearComboProduct,
        clearComboProductList: _clearComboProductList,
        setJoinProductArr: _setJoinProductArr,
        setJoinProductObArr: _setJoinProductObArr,
        setMobileAuthObArr: _setMobileAuthObArr,
        setCusInfoObArr: _setCusInfoObArr,
        setComboProductObArr: _setComboProductObArr,
        setComboProductListObArr: _setComboProductListObArr,
    }
}
